export function AdminLayout({ children }) {
  // Theme is now managed by ThemeProviderWithRouter at the App level
  // This layout just passes children through
  return children;
}

export default AdminLayout;
